import Navbar from "../../components/common/Navbar.js";
import styled from "styled-components";
import SignUpForm from "../../components/auth/SignUpForm.js";
import { useState } from "react";
import LoginForm from "../../components/auth/LoginForm";
import Content from "../../components/landing/Content";
import Footer from "../../components/common/Footer.js";

const Landing = ({}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [showLogin, setShowLogin] = useState(false);
  const toggleLogin = () => setShowLogin(!showLogin);

  return (
    <>
      <Navbar />

      {/* <button
          type="button"
          className="btn btn-primary mt-2"
          onClick={toggleModal}
        >
          Sign Up
        </button> */}
      {/* <h1 class="text-center mb-4 mt-5">Welcome <br></br>to <br></br>Virtual Gaming Community</h1> */}

      <Content />

      {modalOpen ? (
        showLogin ? (
          <LoginForm
            toggleModal={toggleModal}
            modalOpen={modalOpen}
            toggleLogin={toggleLogin}
          />
        ) : (
          <SignUpForm
            toggleModal={toggleModal}
            modalOpen={modalOpen}
            toggleLogin={toggleLogin}
          />
        )
      ) : null}
      <Footer />
    </>
  );
};

export default Landing;

const ImgContainer = styled.div`
  /* width: 70%; */
  max-width: 400px;
  aspect-ratio: 1/1;
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
`;
